const header = document.getElementById('header');
const burger = document.querySelector('.navigation-container .burger') as HTMLElement;
const metanav = document.getElementById('metanav');
const oldMetanavPos = metanav.parentElement;
const navbarmain = document.getElementById('mainnav');

const toggleNav = (): void => {
    document.body.classList.toggle('menu-open');

    if (document.body.classList.contains('menu-open')) {
        navbarmain.after(metanav);
    } else {
        oldMetanavPos.insertAdjacentElement('afterbegin', metanav);
    }
}

// mobile nav
burger.addEventListener('click', () => toggleNav());

// mobile subnav
navbarmain.querySelectorAll('.has-dropdown > li > a').forEach(dropdownTrigger => {
    dropdownTrigger.addEventListener('click', e => {
        if (document.body.classList.contains('menu-open')) {
            e.preventDefault();
            (e.target as HTMLElement).classList.toggle('is-active');
        }
    });
});

// onepager mobile nav
if (window.pageId === 1 && document.documentElement.classList.contains('is-onepager')) {
    navbarmain.querySelectorAll('a[href^="#"]:not(.dropdown-parent)').forEach(link => {
        link.addEventListener('click', () => {
            if (document.body.classList.contains('menu-open')) {
                toggleNav();
            }
        });
    });
}
